module.exports = __webpack_public_path__ + "static/media/CKX.94265d3d.png";